module.exports = __webpack_public_path__ + "static/media/ht.3ac3f598.svg";